import { render, staticRenderFns } from "./bongoMarketing.vue?vue&type=template&id=543902e6&"
import script from "./bongoMarketing.vue?vue&type=script&lang=js&"
export * from "./bongoMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports